'use client'

import { version } from '@/version'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const VersionCheck: FC = () => {
  const [shouldRefresh, setShouldRefresh] = useState(false)
  const {t} = useTranslation()

  useEffect(() => {
    const id = setInterval(() => {
      void fetch(new Request('/api/version'))
        .then(async response => {
          const result = await response.json()

          const next = result.version !== version

          if (shouldRefresh !== next) {
            setShouldRefresh(next)
          }
        })
    }, 30000)

    return () => clearInterval(id)
  }, [shouldRefresh])

  if (shouldRefresh) {
    return (
      <div
        onClick={() => {
          window.location.href = `${window.location.href}`
        }}
        style={{
          background: '#EB6435',
          bottom: 0,
          color: '#FFF',
          cursor: 'pointer',
          fontSize: 20,
          fontWeight: 'bold',
          left: 0,
          letterSpacing: 0.6,
          padding: 20,
          position: 'fixed',
          right: 0,
          textAlign: 'center',
          zIndex: 999999,
        }}
      >
        {t('new-version-released', 'New Version was released, click here to load it')}
      </div>
    )
  }

  return null
}
